module.exports = "<span ng-message=pattern>* Valid website address required. Websites must begin with http:// or https://</span> ";